import React from 'react';
import { Card, CardContent, Typography, Box, Chip} from '@mui/material';

import * as CONSTANTS from "../../constants"
import { MovementCategoriesMapping } from '../../mappings/movementCategories';


const MovementCard = ({movement, lang}) => {

    return (
        <Card>
            {/* Make the whole card clickable */}
            <CardContent>
                {/* Card content info */}
                <Box ml={2} >
                    <Typography variant="h6" component="div" color="textPrimary" sx={{ fontWeight: 'bold' }}>
                        {movement.name}
                    </Typography>
                    <Box minHeight={'1.75rem'} justifyItems={'center'}>
                        {movement.categories.map((category) => (
                            <Chip
                                label={MovementCategoriesMapping[category][lang]}
                                variant="outlined"
                                size='small'
                                sx={{
                                    borderRadius: '0.5rem',
                                    // backgroundColor: '#f0f0f0',
                                    borderColor: '#ccc',
                                    marginRight: '0.25rem',
                                    marginTop: '0.25rem',
                                }}
                            />
                        ))}
                    </Box>
                    <Box sx={{ m: 1 }} />
                    <Typography variant="body2" color="textSecondary">
                        {movement.description}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default MovementCard;